<template>
    <v-container>
      <!-- Responsive grid container -->
      <v-row class="d-flex justify-center flex-wrap"> 
        <!-- Vuetify toggle button component for grouping buttons -->
        <v-btn-toggle
          mandatory
          :model-value="selected"
          @update:model-value="updateChoice"
        >

        <v-row class="d-flex justify-center flex-wrap pa-3">
          <!-- Buttons for each option -->
          <v-btn class="option-btn">
            <i v-if="selected==0" class="mdi mdi-check"></i>
            Educational
          </v-btn>

          <v-btn class="option-btn">
            <i v-if="selected==1" class="mdi mdi-check"></i>
            Coping
          </v-btn>  

          <v-btn class="option-btn">
            <i v-if="selected==2" class="mdi mdi-check"></i>
            Processing
          </v-btn>

          <v-btn class="option-btn">
            <i v-if="selected==3" class="mdi mdi-check"></i>
            Assessments
          </v-btn>        
        </v-row>
  
        </v-btn-toggle> 
      </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'SelectionToggle',
    data() {
        return {
            'options': ['Educational', 'Coping', 
            'Processing', 'Assessments'],
            'selected': 0 
        }
    },
    props: {
        'choice': Number,
        'name': String
    },
    emits: ['update:choice', 'update:name'],
    methods: {
        // Method to update modelValue and valueString props
        updateChoice(newValue){
            this.selected = newValue
            this.$emit('update:choice', newValue);
            this.$emit('update:name', this.options[newValue]);
        }
    } 
}

</script>
<style scoped>
/* MEND branding */
.option-btn{ 
    width: 150px;
    font-family: 'Montserrat', sans-serif;
}

</style>